<script lang="ts">
	import { getUserPortfolioValues } from '$lib/data/portfolio';
	import { smartContractWalletAddress } from '$lib/home/scwallet/store';
	import GradientBorder from '$lib/util/GradientBorder.svelte';
	import { walletAddress, walletConnected } from '$lib/wallet/store';
	import PortfolioChart from './PortfolioChart.svelte';

	$: if ($walletConnected && $walletAddress && $smartContractWalletAddress) {
		getUserPortfolioValues();
	}
</script>

<GradientBorder
	gradient="sm:bg-fx-gradient-6"
	paddingClass="p-px"
	borderRadius="rounded-xl squircle-xl"
	outerClassList="w-full"
	innerClassList="flex justify-center items-center sm:bg-fx-black w-full h-full"
>
	<div
		class="sm:px-6 sm:py-6 flex flex-col items-start w-full h-full rounded-xl squircle-xl sm:bg-fx-gradient-8-50"
	>
		<PortfolioChart />
	</div>
</GradientBorder>
